import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ConfigurationsModelKeys } from '../models/configurations.model';
import { ConfigurationsRepository } from '../repositories/configurarions.repository';

export class GetConfigParamsUseCase<T>
    implements UseCase<ConfigurationsModelKeys, T>
{
    constructor(private readonly repository: ConfigurationsRepository) {}

    execute(param: ConfigurationsModelKeys): Observable<T> {
        return this.repository.getConfig<T>(param);
    }
}
